import HighchartsReact from 'highcharts-react-official';
import Highcharts from 'highcharts';
import { useDatabaseSize } from '../../Hooks/Features/Inspectra/useDatabaseSize';
import { Dialog } from 'primereact/dialog';
import { SkeletonContainer } from "../Loader/Loader.jsx";
import { MultiSelect } from 'primereact/multiselect';
import PanelHeaderTemplate from "../CommonCompo/PanelHeadeTemplate/PanelHeaderTemplate.jsx";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const DatabaseSize = ({ projectChanged }) => {

    const { options, showPopup, setShowPopup, popupData, databaseData, loader, showFilter, setShowFilter, filterOpts, filterValues, setFilterValues, filterCount, expand, setExpand, handleApplyFilters } = useDatabaseSize({ projectChanged });

    return (
        <div className="inspectra-widget-container p-2">
            <div className="d-flex justify-content-between align-items-center">
                <div className="inspectra-widget-header">Database Size Status</div>
                <div className="text-primary inspectra-cursor inspectra-filter d-flex gap-1 align-items-center" onClick={() => setShowFilter(true)}><span className="inspectra-filter-count">{filterCount}</span>filters</div>
            </div>
            <div className='inspectra-widget-content'>
                {loader ? <SkeletonContainer /> :
                    (databaseData?.api_data?.length > 0 && <HighchartsReact className="highcharts-container" highcharts={Highcharts} options={options} containerProps={{
                        style: {
                            height: "99%"
                        }
                    }} />
                )}
            </div>

            <div className="position-absolute bottom-0 end-0 me-1 fs-6 c-pointer" onClick={() => setExpand(true)}>
                <FontAwesomeIcon icon="fa-solid fa-expand" />
            </div>

            <Dialog visible={showFilter} onHide={() => setShowFilter(false)} className="modal-small" draggable={false} header="Database Size Status Filters">
                <div>
                    <div className="w50">
                        <div>Database:</div>
                        <MultiSelect options={filterOpts?.dbname} placeholder="Database" value={filterValues?.dbname} onChange={(e) => setFilterValues((prev) => ({ ...prev, dbname: e.target.value }))} panelHeaderTemplate={(options) => PanelHeaderTemplate(options, 'dbname', filterValues?.dbname, () => setFilterValues((prev) => ({ ...prev, dbname: [] })))} filter filterInputAutoFocus />
                    </div>
                    <div className="d-flex justify-content-between align-items-center mt-2">
                        <div className="text-primary c-pointer" onClick={() => setFilterValues((prev) => ({ ...prev, dbname: [] }))}>Select default filters</div>
                        <button className="button btn-primary" onClick={() => handleApplyFilters()}>Apply</button>
                    </div>
                </div>
            </Dialog>

            <Dialog visible={showPopup} onHide={() => setShowPopup(false)} draggable={false} className='modal-large inspectra-grey-dialog' header="Database Size Details">
                <div>
                    {popupData?.map((item, index) => (
                        <div key={index} className="inspectra-popup-card">
                            <div className="d-flex mb-1">
                                <div className="w30 fw-bold">Database Name:</div>
                                <div className="w70 text-wrap">{item?.database_name}</div>
                            </div>

                            <div className="d-flex mb-1">
                                <div className="w30 fw-bold">SQL Server Version:</div>
                                <div className="w70 text-wrap">{item?.sql_server_version}</div>
                            </div>

                            <div className="d-flex mb-1">
                                <div className="w30 fw-bold">Data File Size:</div>
                                <div className="w70 text-wrap">{item?.db_row_size_mb} MB</div>
                            </div>

                            <div className="d-flex mb-1">
                                <div className="w30 fw-bold">Log File Size:</div>
                                <div className="w70 text-wrap">{item?.db_log_size_mb} MB</div>
                            </div>

                            <div className="d-flex mb-1">
                                <div className="w30 fw-bold">Total Size:</div>
                                <div className="w70 text-wrap">{item?.db_total_size_mb} MB</div>
                            </div>

                        </div>
                    ))}
                </div>
            </Dialog>

            <Dialog visible={expand} onHide={() => setExpand(false)} className="modal-xlarge" draggable={false} header="Database Size Status Expanded">
                <div>
                    <div className="text-primary inspectra-cursor inspectra-filter d-flex gap-1 align-items-center justify-content-end" onClick={() => setShowFilter(true)}>
                        <span className="inspectra-filter-count">{filterCount}</span>filters
                    </div>
                    <HighchartsReact className="highcharts-container" highcharts={Highcharts} options={options} containerProps={{
                        style: {
                            height: "99%"
                        }
                    }} />
                </div>
            </Dialog>
        </div>
    )
}

export default DatabaseSize;